//Actions related to investorid
export const USERS_FETCH_START = "USERS_FETCH_START";
export const USERS_FETCH_SUCCESS = "USERS_FETCH_SUCCESS";
export const USERS_FETCH_FAILURE = "USERS_FETCH_FAILURE";

//Actions related to investorid
export const INVESTOR_ID_FETCH_START = "INVESTOR_ID_FETCH_START";
export const INVESTOR_ID_FETCH_SUCCESS = "INVESTOR_ID_FETCH_SUCCESS";
export const INVESTOR_ID_FETCH_FAILURE = "INVESTOR_ID_FETCH_FAILURE";

//Actions related to home page content

export const HOME_FETCH_START = "HOME_FETCH_START";
export const HOME_FETCH_SUCCESS = "HOME_FETCH_SUCCESS";
export const HOME_FETCH_FAILURE = "HOME_FETCH_FAILURE";

//Actions related to account page content

export const ACCOUNT_FETCH_START = "ACCOUNT_FETCH_START";
export const ACCOUNT_FETCH_SUCCESS = "ACCOUNT_FETCH_SUCCESS";
export const ACCOUNT_FETCH_FAILURE = "ACCOUNT_FETCH_FAILURE";

export const ACCOUNT_PATCH_START = "ACCOUNT_PATCH_START";
export const ACCOUNT_PATCH_SUCCESS = "ACCOUNT_PATCH_SUCCESS";
export const ACCOUNT_PATCH_FAILURE = "ACCOUNT_PATCH_FAILURE";

export const UPLOAD_DOC_PATCH_START = "UPLOAD_DOC_PATCH_START";
export const UPLOAD_DOC_PATCH_SUCCESS = "UPLOAD_DOC_PATCH_SUCCESS";
export const UPLOAD_DOC_PATCH_FAILURE = "UPLOAD_DOC_PATCH_FAILURE";

export const SUBMIT_DOC_PATCH_START = "SUBMIT_DOC_PATCH_START";
export const SUBMIT_DOC_PATCH_SUCCESS = "SUBMIT_DOC_PATCH_SUCCESS";
export const SUBMIT_DOC_PATCH_FAILURE = "SUBMIT_DOC_PATCH_FAILURE";

//Actions related to member type

export const MEMBER_TYPE_FETCH_START = "MEMBER_TYPE_FETCH_START";
export const MEMBER_TYPE_FETCH_SUCCESS = "MEMBER_TYPE_FETCH_SUCCESS";
export const MEMBER_TYPE_FETCH_FAILURE = "MEMBER_TYPE_FETCH_FAILURE";

//Actions related to total pot info

export const TOTAL_POTINFO_FETCH_START = "TOTAL_POTINFO_FETCH_START";
export const TOTAL_POTINFO_FETCH_SUCCESS = "TOTAL_POTINFO_FETCH_SUCCESS";
export const TOTAL_POTINFO_FETCH_FAILURE = "TOTAL_POTINFO_FETCH_FAILURE";

//Actions related to manage page content

export const MANAGE_FETCH_START = "MANAGE_FETCH_START";
export const MANAGE_FETCH_SUCCESS = "MANAGE_FETCH_SUCCESS";
export const MANAGE_FETCH_FAILURE = "MANAGE_FETCH_FAILURE";

export const POST_CONTRIBUTION_RATES_FETCH_START =
  "POST_CONTRIBUTION_RATES_FETCH_START";
export const POST_CONTRIBUTION_RATES_FETCH_SUCCESS =
  "POST_CONTRIBUTION_RATES_FETCH_SUCCESS";
export const POST_CONTRIBUTION_RATES_FETCH_FAILURE =
  "POST_CONTRIBUTION_RATES_FETCH_FAILURE";
export const RESET_CONTRIBUTION_RATES_DATA = "RESET_CONTRIBUTION_RATES_DATA";

//Actions related to fund history

export const FUND_HISTORY_FETCH_START = "FUND_HISTORY_FETCH_START";
export const FUND_HISTORY_FETCH_SUCCESS = "FUND_HISTORY_FETCH_SUCCESS";
export const FUND_HISTORY_FETCH_FAILURE = "FUND_HISTORY_FETCH_FAILURE";

//Actions related to Address lookup

export const ADDRESS_FETCH_START = "ADDRESS_FETCH_START";
export const ADDRESS_FETCH_SUCCESS = "ADDRESS_FETCH_SUCCESS";
export const ADDRESS_FETCH_FAILURE = "ADDRESS_FETCH_FAILURE";

//Actions related to funds-savings

export const FUNDS_SAVINGS_FETCH_START = "FUNDS_SAVINGS_FETCH_START";
export const FUNDS_SAVINGS_FETCH_SUCCESS = "FUNDS_SAVINGS_FETCH_SUCCESS";
export const FUNDS_SAVINGS_FETCH_FAILURE = "FUNDS_SAVINGS_FETCH_FAILURE";
//Actions related to member-list

export const MEMBER_LIST_FETCH_START = "MEMBER_LIST_FETCH_START";
export const MEMBER_LIST_FETCH_SUCCESS = "MEMBER_LIST_FETCH_SUCCESS";
export const MEMBER_LIST_FETCH_FAILURE = "MEMBER_LIST_FETCH_FAILURE";

export const MEMBER_DETAILS_FETCH_START = "MEMBER_DETAILS_FETCH_START";
export const MEMBER_DETAILS_FETCH_SUCCESS = "MEMBER_DETAILS_FETCH_SUCCESS";
export const MEMBER_DETAILS_FETCH_FAILURE = "MEMBER_DETAILS_FETCH_FAILURE";

//Actions related to retirement application

export const RETIREMENT_APPLICATION_FETCH_START =
  "RETIREMENT_APPLICATION_FETCH_START";
export const RETIREMENT_APPLICATION_FETCH_SUCCESS =
  "RETIREMENT_APPLICATION_FETCH_SUCCESS";
export const RETIREMENT_APPLICATION_FETCH_FAILURE =
  "RETIREMENT_APPLICATION_FETCH_FAILURE";
export const SET_RETIREMENT_APPLICATION_DETAILS =
  "SET_RETIREMENT_APPLICATION_DETAILS";
export const BEGIN_RETIREMENT_APPLICATION_CLICK_START =
  "BEGIN_RETIREMENT_APPLICATION_CLICK_START";
export const MODIFY_RETIREMENT_APPLICATION_STEPS =
  "MODIFY_RETIREMENT_APPLICATION_STEPS";
export const BACK_BUTTON_RETIREMENT_APPLICATION_STEPS =
  "BACK_BUTTON_RETIREMENT_APPLICATION_STEPS";
export const NEXT_BUTTON_RETIREMENT_APPLICATION_STEPS =
  "NEXT_BUTTON_RETIREMENT_APPLICATION_STEPS";
export const RETIREMENT_CHOOSE_APPLICATION_SUB_STEPS =
  "RETIREMENT_CHOOSE_APPLICATION_SUB_STEPS";
export const RETIREMENT_CONFIRM_CHOICE_SUB_STEPS =
  "RETIREMENT_CONFIRM_CHOICE_SUB_STEPS";
export const RETIREMENT_DIRECT_STEP_CHANGE = "RETIREMENT_DIRECT_STEP_CHANGE";
export const RETIREMENT_CHOOSE_START_AGAIN_POT_SELECTION =
  "RETIREMENT_CHOOSE_START_AGAIN_POT_SELECTION";

// Actions related to zendesk chat token
export const CHAT_TOKEN_START = "CHAT_TOKEN_START";
export const CHAT_TOKEN_SUCCESS = "CHAT_TOKEN_SUCCESS";
export const CHAT_TOKEN_FAILURE = "CHAT_TOKEN_FAILURE";

export const SCHEME_PROTECTION_FETCH_START = "SCHEME_PROTECTION_FETCH_START";
export const SCHEME_PROTECTION_FETCH_SUCCESS =
  "SCHEME_PROTECTION_FETCH_SUCCESS";
export const SCHEME_PROTECTION_FETCH_FAILURE =
  "SCHEME_PROTECTION_FETCH_FAILURE";

//Actions related to retirement application

export const BENEFICIARY_FETCH_START = "BENEFICIARY_FETCH_START";
export const BENEFICIARY_FETCH_SUCCESS = "BENEFICIARY_FETCH_SUCCESS";
export const BENEFICIARY_FETCH_FAILURE = "BENEFICIARY_FETCH_FAILURE";

export const BENEFICIARY_POST_FETCH_START = "BENEFICIARY_POST_FETCH_START";
export const BENEFICIARY_POST_FETCH_SUCCESS = "BENEFICIARY_POST_FETCH_SUCCESS";
export const BENEFICIARY_POST_FETCH_FAILURE = "BENEFICIARY_POST_FETCH_FAILURE";

export const BENEFICIARY_PATCH_FETCH_START = "BENEFICIARY_PATCH_FETCH_START";
export const BENEFICIARY_PATCH_FETCH_SUCCESS =
  "BENEFICIARY_PATCH_FETCH_SUCCESS";
export const BENEFICIARY_PATCH_FETCH_FAILURE =
  "BENEFICIARY_PATCH_FETCH_FAILURE";

//Actions related to transactions summary

export const TRANSACTIONS_SUMMARY_FETCH_START =
  "TRANSACTIONS_SUMMARY_FETCH_START";
export const TRANSACTIONS_SUMMARY_FETCH_SUCCESS =
  "TRANSACTIONS_SUMMARY_FETCH_SUCCESS";
export const TRANSACTIONS_SUMMARY_FETCH_FAILURE =
  "TRANSACTIONS_SUMMARY_FETCH_FAILURE";

// Actions to fetch new access token
export const FETCH_REFRESH_TOKEN_START = "FETCH_REFRESH_TOKEN_START";
export const FETCH_REFRESH_TOKEN_SUCCESS = "FETCH_REFRESH_TOKEN_SUCCESS";
export const FETCH_REFRESH_TOKEN_FAILURE = "FETCH_REFRESH_TOKEN_FAILURE";
//Actions related to transferIn

export const TRANSERIN_FETCH_START = "TRANSERIN_FETCH_START";
export const TRANSERIN_FETCH_SUCCESS = "TRANSERIN_FETCH_SUCCESS";
export const TRANSERIN_FETCH_FAILURE = "TRANSERIN_FETCH_FAILURE";

//Actions related to retirement application - patch each step

export const RETIREMENT_APPLICATION_PATCH_START =
  "RETIREMENT_APPLICATION_PATCH_START";
export const RETIREMENT_APPLICATION_PATCH_SUCCESS =
  "RETIREMENT_APPLICATION_PATCH_SUCCESS";
export const RETIREMENT_APPLICATION_PATCH_FAILURE =
  "RETIREMENT_APPLICATION_PATCH_FAILURE";

//Actions related to Retirement guidance explorer

export const GUIDANCE_EXPLORER_FETCH_START = "GUIDANCE_EXPLORER_FETCH_START";
export const GUIDANCE_EXPLORER_SUCCESS = "GUIDANCE_EXPLORER_SUCCESS";
export const GUIDANCE_EXPLORER_FAILURE = "GUIDANCE_EXPLORER_FAILURE";

//Actions related to Retirement guidance explorer card

export const GUIDANCE_EXPLORER_CARD_FETCH_START =
  "GUIDANCE_EXPLORER_CARD_FETCH_START";
export const GUIDANCE_EXPLORER_CARD_SUCCESS = "GUIDANCE_EXPLORER_CARD_SUCCESS";
export const GUIDANCE_EXPLORER_CARD_FAILURE = "GUIDANCE_EXPLORER_CARD_FAILURE";

export const CMS_FUND_LIST_FETCH_START = "CMS_FUND_LIST_FETCH_START";
export const CMS_FUND_LIST_FETCH_SUCCESS = "CMS_FUND_LIST_FETCH_SUCCESS";
export const CMS_FUND_LIST_FETCH_FAILURE = "CMS_FUND_LIST_FETCH_FAILURE";

//Actions related to Retirement living standard

export const LIVING_STANDARD_FETCH_START = "LIVING_STANDARD_FETCH_START";
export const LIVING_STANDARD_FETCH_SUCCESS = "LIVING_STANDARD_FETCH_SUCCESS";
export const LIVING_STANDARD_FETCH_FAILURE = "LIVING_STANDARD_FETCH_FAILURE";

export const LIVING_STANDARD_ASSUMPTIONS_FETCH_START =
  "LIVING_STANDARD_ASSUMPTIONS_FETCH_START";
export const LIVING_STANDARD_ASSUMPTIONS_FETCH_SUCCESS =
  "LIVING_STANDARD_ASSUMPTIONS_FETCH_SUCCESS";
export const LIVING_STANDARD_ASSUMPTIONS_FETCH_FAILURE =
  "LIVING_STANDARD_ASSUMPTIONS_FETCH_FAILURE";

//Actions related to Product overview
export const PRODUCT_OVERVIEW_FETCH_START = "PRODUCT_OVERVIEW_FETCH_START";
export const PRODUCT_OVERVIEW_FETCH_SUCCESS = "PRODUCT_OVERVIEW_FETCH_SUCCESS";
export const PRODUCT_OVERVIEW_FETCH_FAILURE = "PRODUCT_OVERVIEW_FETCH_FAILURE";
//Actions related to document

export const ALL_DOCUMENTS_FETCH_START = "ALL_DOCUMENTS_FETCH_START";
export const ALL_DOCUMENTS_FETCH_SUCCESS = "ALL_DOCUMENTS_FETCH_SUCCESS";
export const ALL_DOCUMENTS_FETCH_FAILURE = "ALL_DOCUMENTS_FETCH_FAILURE";
export const GET_DOCUMENT_FETCH_START = "GET_DOCUMENT_FETCH_START";
export const GET_DOCUMENT_FETCH_SUCCESS = "GET_DOCUMENT_FETCH_SUCCESS";
export const GET_DOCUMENT_FETCH_FAILURE = "GET_DOCUMENT_FETCH_FAILURE";
export const DOCUMENT_READ_STATUS_POST_FETCH_START =
  "DOCUMENT_READ_STATUS_POST_FETCH_START";
export const DOCUMENT_READ_STATUS_POST_FETCH_SUCCESS =
  "DOCUMENT_READ_STATUS_POST_FETCH_SUCCESS";
export const DOCUMENT_READ_STATUS_POST_FETCH_FAILURE =
  "DOCUMENT_READ_STATUS_POST_FETCH_FAILURE";
export const RESET_GET_DOCUMENT_DATA = "RESET_GET_DOCUMENT_DATA";
export const RESET_GET_DOCUMENT_ERROR = "RESET_GET_DOCUMENT_ERROR";

//Actions related to comm preference
export const COMM_PREFERENCE_FETCH_START = "COMM_PREFERENCE_FETCH_START";
export const COMM_PREFERENCE_FETCH_SUCCESS = "COMM_PREFERENCE_FETCH_SUCCESS";
export const COMM_PREFERENCE_FETCH_FAILURE = "COMM_PREFERENCE_FETCH_FAILURE";
// GetIn Touch upload document
export const UPLOAD_DOC_GETINTOUCH_START = "UPLOAD_DOC_GETINTOUCH_START";
export const UPLOAD_DOC_GETINTOUCH_SUCCESS = "UPLOAD_DOC_GETINTOUCH_SUCCESS";
export const UPLOAD_DOC_GETINTOUCH_FAILURE = "UPLOAD_DOC_GETINTOUCH_FAILURE";
export const UPLOAD_DOC_GETINTOUCH_RESET = "UPLOAD_DOC_GETINTOUCH_RESET";
//Actions related to Footer content
export const FOOTER_CONTENT_FETCH_START = "FOOTER_CONTENT_FETCH_START";
export const FOOTER_CONTENT_FETCH_SUCCESS = "FOOTER_CONTENT_FETCH_SUCCESS";
export const FOOTER_CONTENT_FETCH_FAILURE = "FOOTER_CONTENT_FETCH_FAILURE";

//Actions related to your goals
export const YOUR_GOALS_FETCH_START = "YOUR_GOALS_FETCH_START";
export const YOUR_GOALS_FETCH_SUCCESS = "YOUR_GOALS_FETCH_SUCCESS";
export const YOUR_GOALS_FETCH_FAILURE = "YOUR_GOALS_FETCH_FAILURE";

export const POST_YOUR_GOALS_FETCH_START = "POST_YOUR_GOALS_FETCH_START";
export const POST_YOUR_GOALS_FETCH_SUCCESS = "POST_YOUR_GOALS_FETCH_SUCCESS";
export const POST_YOUR_GOALS_FETCH_FAILURE = "POST_YOUR_GOALS_FETCH_FAILURE";
//Actions related to Learn Landing
export const LEARN_LANDING_FETCH_START = "LEARN_LANDING_FETCH_START";
export const LEARN_LANDING_FETCH_SUCCESS = "LEARN_LANDING_FETCH_SUCCESS";
export const LEARN_LANDING_FETCH_FAILURE = "LEARN_LANDING_FETCH_FAILURE";
export const LEARN_LANDING_FILTER_FETCH_START =
  "LEARN_LANDING_FILTER_FETCH_START";
export const LEARN_LANDING_FILTER_FETCH_SUCCESS =
  "LEARN_LANDING_FILTER_FETCH_SUCCESS";
export const LEARN_LANDING_FILTER_FETCH_FAILURE =
  "LEARN_LANDING_FILTER_FETCH_FAILURE";
export const LEARN_LANDING_FAQ_FETCH_START = "LEARN_LANDING_FAQ_FETCH_START";
export const LEARN_LANDING_FAQ_FETCH_SUCCESS =
  " LEARN_LANDING_FAQ_FETCH_SUCCESS";
export const LEARN_LANDING_FAQ_FETCH_FAILURE =
  "LEARN_LANDING_FAQ_FETCH_FAILURE";

//Future calculator
export const FC_HOME_FETCH_START = "FC_HOME_FETCH_START";
export const FC_HOME_FETCH_SUCCESS = "FC_HOME_FETCH_SUCCESS";
export const FC_HOME_FETCH_FAILURE = "FC_HOME_FETCH_FAILURE";

//Actions related to Learn Support
export const LEARN_LANDING_JARGON_BUSTER_FETCH_START =
  "LEARN_LANDING_JARGON_BUSTER_FETCH_START";
export const LEARN_LANDING_JARGON_BUSTER_FETCH_SUCCESS =
  "LEARN_LANDING_JARGON_BUSTER_FETCH_SUCCESS";
export const LEARN_LANDING_JARGON_BUSTER_FETCH_FAILURE =
  "LEARN_LANDING_JARGON_BUSTER_FETCH_FAILURE";

//Actions related to IWantToCombo
export const I_WANT_TO_COMBO_FETCH_START = "I_WANT_TO_COMBO_FETCH_START";
export const I_WANT_TO_COMBO_FETCH_SUCCESS = "I_WANT_TO_COMBO_FETCH_SUCCESS";
export const I_WANT_TO_COMBO_FETCH_FAILURE = "I_WANT_TO_COMBO_FETCH_FAILURE";

export const INVESTMENT_DATA_FETCH_START = "INVESTMENT_DATA_FETCH_START";
export const INVESTMENT_DATA_FETCH_SUCCESS = "INVESTMENT_DATA_FETCH_SUCCESS";
export const INVESTMENT_DATA_FETCH_FAILURE = "INVESTMENT_DATA_FETCH_FAILURE";

export const CALCULATE_POT_FETCH_START = "CALCULATE_POT_FETCH_START";
export const CALCULATE_POT_FETCH_SUCCESS = "CALCULATE_POT_FETCH_SUCCESS";
export const CALCULATE_POT_FETCH_MODAL_SUCCESS =
  "CALCULATE_POT_FETCH_MODAL_SUCCESS";
export const CALCULATE_POT_FETCH_FAILURE = "CALCULATE_POT_FETCH_FAILURE";

//Actions related to Retirement QR code

export const RETIREMENT_QR_START = "RETIREMENT_QR_START";
export const RETIREMENT_QR_SUCCESS = "RETIREMENT_QR_SUCCESS";
export const RETIREMENT_QR_FAILURE = "RETIREMENT_QR_FAILURE";
//Actions related to Retirement QR code

export const RETIREMENT_IDENTITY_FETCH_START = "RETIREMENT_QR_START";
export const RETIREMENT_IDENTITY_FETCH_SUCCESS = "RETIREMENT_QR_SUCCESS";
export const RETIREMENT_IDENTITY_FETCH_FAILURE = "RETIREMENT_QR_FAILURE";

//Actions related to get notifications
export const NOTIFICATION_FETCH_START = "NOTIFICATION_FETCH_START";
export const NOTIFICATION_FETCH_SUCCESS = "NOTIFICATION_FETCH_SUCCESS";
export const NOTIFICATION_FETCH_FAILURE = "NOTIFICATION_FETCH_FAILURE";

export const HOME_PROMO_FETCH_START = "HOME_PROMO_FETCH_START";
export const HOME_PROMO_FETCH_SUCCESS = "HOME_PROMO_FETCH_SUCCESS";
export const HOME_PROMO_FETCH_FAILURE = "HOME_PROMO_FETCH_FAILURE";

export const TIME_TRAVEL_ASSUMPTIONS_FETCH_START =
  "TIME_TRAVEL_ASSUMPTIONS_FETCH_START";
export const TIME_TRAVEL_ASSUMPTIONS_FETCH_SUCCESS =
  "TIME_TRAVEL_ASSUMPTIONS_FETCH_SUCCESS";
export const TIME_TRAVEL_ASSUMPTIONS_FETCH_FAILURE =
  "TIME_TRAVEL_ASSUMPTIONS_FETCH_FAILURE";

export const CONTRIBUTION_RATES_FETCH_START = "CONTRIBUTION_RATES_FETCH_START";
export const CONTRIBUTION_RATES_FETCH_SUCCESS =
  "CONTRIBUTION_RATES_FETCH_SUCCESS";
export const CONTRIBUTION_RATES_FETCH_FAILURE =
  "CONTRIBUTION_RATES_FETCH_FAILURE";

export const CALCULATOR_CMS_CONFIG_FETCH_START =
  "CALCULATOR_CMS_CONFIG_FETCH_START";
export const CALCULATOR_CMS_CONFIG_FETCH_SUCCESS =
  "CALCULATOR_CMS_CONFIG_FETCH_SUCCESS";
export const CALCULATOR_CMS_CONFIG_FETCH_FAILURE =
  "CALCULATOR_CMS_CONFIG_FETCH_FAILURE";

export const CONTRIBUTION_CALCULATOR_POST_FETCH_START =
  "CONTRIBUTION_CALCULATOR_POST_FETCH_START";
export const CONTRIBUTION_CALCULATOR_POST_FETCH_SUCCESS =
  "CONTRIBUTION_CALCULATOR_POST_FETCH_SUCCESS";
export const CONTRIBUTION_CALCULATOR_POST_FETCH_FAILURE =
  "CONTRIBUTION_CALCULATOR_POST_FETCH_FAILURE";

export const HOME_ALERT_FETCH_START = "HOME_ALERT_FETCH_START";
export const HOME_ALERT_FETCH_SUCCESS = "HOME_ALERT_FETCH_SUCCESS";
export const HOME_ALERT_FETCH_FAILURE = "HOME_ALERT_FETCH_FAILURE";
//Actions related to TRA
export const TRA_POST_FETCH_START = "TRA_POST_FETCH_START";
export const TRA_POST_FETCH_SUCCESS = "TRA_POST_FETCH_SUCCESS";
export const TRA_POST_FETCH_FAILURE = "TRA_POST_FETCH_FAILURE";

//Connected pension
export const CONNECTED_PENSION_FETCH_START = "CONNECTED_PENSION_FETCH_START";
export const CONNECTED_PENSION_FETCH_SUCCESS =
  "CONNECTED_PENSION_FETCH_SUCCESS";
export const CONNECTED_PENSION_FETCH_FAILURE =
  "CONNECTED_PENSION_FETCH_FAILURE";

//Future calculator flexi result
export const FC_FLEXI_RESULT_FETCH_START = "FC_FLEXI_RESULT_FETCH_START";
export const FC_FLEXI_RESULT_FETCH_SUCCESS = "FC_FLEXI_RESULT_FETCH_SUCCESS";
export const FC_FLEXI_RESULT_FETCH_FAILURE = "FC_FLEXI_RESULT_FETCH_FAILURE";

//Future calculator managed income result
export const FC_INCOME_RESULT_FETCH_START = "FC_INCOME_RESULT_FETCH_START";
export const FC_INCOME_RESULT_FETCH_SUCCESS = "FC_INCOME_RESULT_FETCH_SUCCESS";
export const FC_INCOME_RESULT_FETCH_FAILURE = "FC_INCOME_RESULT_FETCH_FAILURE";

//Future calculator annuity result
export const FC_ANNUITY_RESULT_FETCH_START = "FC_ANNUITY_RESULT_FETCH_START";
export const FC_ANNUITY_RESULT_FETCH_SUCCESS =
  "FC_ANNUITY_RESULT_FETCH_SUCCESS";
export const FC_ANNUITY_RESULT_FETCH_FAILURE =
  "FC_ANNUITY_RESULT_FETCH_FAILURE";

//Contribution calculator worth amount
export const FC_WORTH_AMOUNT_FETCH_START = "FC_WORTH_AMOUNT_FETCH_START";
export const FC_WORTH_AMOUNT_FETCH_SUCCESS = "FC_WORTH_AMOUNT_FETCH_SUCCESS";
export const FC_WORTH_AMOUNT_FETCH_FAILURE = "FC_WORTH_AMOUNT_FETCH_FAILURE";

//About TPT
export const ABOUT_TPT_FETCH_START = "ABOUT_TPT_FETCH_START";
export const ABOUT_TPT_FETCH_SUCCESS = "ABOUT_TPT_FETCH_SUCCESS";
export const ABOUT_TPT_FETCH_FAILURE = "ABOUT_TPT_FETCH_FAILURE";
//FC flexi line chart
export const FC_FLEXI_LINECHART_FETCH_START = "FC_FLEXI_LINECHART_FETCH_START";
export const FC_FLEXI_LINECHART_FETCH_SUCCESS =
  "FC_FLEXI_LINECHART_FETCH_SUCCESS";
export const FC_FLEXI_LINECHART_FETCH_FAILURE =
  "FC_FLEXI_LINECHART_FETCH_FAILURE";

//FC flexi income chart
export const FC_FLEXI_INCOMECHART_FETCH_START =
  "FC_FLEXI_INCOMECHART_FETCH_START";
export const FC_FLEXI_INCOMECHART_FETCH_SUCCESS =
  "FC_FLEXI_INCOMECHART_FETCH_SUCCESS";
export const FC_FLEXI_INCOMECHART_FETCH_FAILURE =
  "FC_FLEXI_INCOMECHART_FETCH_FAILURE";

//FC managed income chart
export const FC_MANAGED_INCOMECHART_FETCH_START =
  "FC_MANAGED_INCOMECHART_FETCH_START";
export const FC_MANAGED_INCOMECHART_FETCH_SUCCESS =
  "FC_MANAGED_INCOMECHART_FETCH_SUCCESS";
export const FC_MANAGED_INCOMECHART_FETCH_FAILURE =
  "FC_MANAGED_INCOMECHART_FETCH_FAILURE";

//FC annuity chart
export const FC_ANNUITYCHART_FETCH_START = "FC_ANNUITYCHART_FETCH_START";
export const FC_ANNUITYCHART_FETCH_SUCCESS = "FC_ANNUITYCHART_FETCH_SUCCESS";
export const FC_ANNUITYCHART_FETCH_FAILURE = "FC_ANNUITYCHART_FETCH_FAILURE";

//FC assumption
export const FC_ASSUMPTIONS_FETCH_START = "FC_ASSUMPTIONS_FETCH_START";
export const FC_ASSUMPTIONS_FETCH_SUCCESS = "FC_ASSUMPTIONS_FETCH_SUCCESS";
export const FC_ASSUMPTIONS_FETCH_FAILURE = "FC_ASSUMPTIONS_FETCH_FAILURE";

//Help Guides
export const LEARN_HELP_GUIDES_FETCH_FAILURE =
  "LEARN_HELP_GUIDES_FETCH_FAILURE";
export const LEARN_HELP_GUIDES_FETCH_SUCCESS =
  "LEARN_HELP_GUIDES_FETCH_SUCCESS";
export const LEARN_HELP_GUIDES_FETCH_START = "LEARN_HELP_GUIDES_FETCH_START";

//Scheme documents
export const SCHEMA_DOCUMENT_FETCH_START = "SCHEMA_DOCUMENT_FETCH_START";
export const SCHEMA_DOCUMENT_FETCH_SUCCESS = "SCHEMA_DOCUMENT_FETCH_SUCCESS";
export const SCHEMA_DOCUMENT_FETCH_FAILURE = "SCHEMA_DOCUMENT_FETCH_FAILURE";

//Scheme documents
export const FUND_SWITCH_FETCH_START = "FUND_SWITCH_FETCH_START";
export const FUND_SWITCH_FETCH_SUCCESS = "FUND_SWITCH_FETCH_SUCCESS";
export const FUND_SWITCH_FETCH_FAILURE = "FUND_SWITCH_FETCH_FAILURE";

export const DRAWDOWN_DATA_FETCH_START = "DRAWDOWN_DATA_FETCH_START";
export const DRAWDOWN_DATA_FETCH_SUCCESS = "DRAWDOWN_DATA_FETCH_SUCCESS";
export const DRAWDOWN_DATA_FETCH_FAILURE = "DRAWDOWN_DATA_FETCH_FAILURE";

export const LEARN_SUPPORT_FETCH_START = "LEARN_SUPPORT_FETCH_START";
export const LEARN_SUPPORT_FETCH_SUCCESS = "LEARN_SUPPORT_FETCH_SUCCESS";
export const LEARN_SUPPORT_FETCH_FAILURE = "LEARN_SUPPORT_FETCH_FAILURE";
// TransferOut
export const TRANSFER_OUT_FETCH_START = "TRANSFER_OUT_FETCH_START";
export const TRANSFER_OUT_FETCH_SUCCESS = "TRANSFER_OUT_FETCH_SUCCESS";
export const TRANSFER_OUT_FETCH_FAILURE = "TRANSFER_OUT_FETCH_FAILURE";

export const LINKS_FETCH_START = "LINKS_FETCH_START";
export const LINKS_FETCH_SUCCESS = "LINKS_FETCH_SUCCESS";
export const LINKS_FETCH_FAILURE = "LINKS_FETCH_FAILURE";

export const MESSAGES_FETCH_START = "MESSAGES_FETCH_START";
export const MESSAGES_FETCH_SUCCESS = "MESSAGES_FETCH_SUCCESS";
export const MESSAGES_FETCH_FAILURE = "MESSAGES_FETCH_FAILURE";

export const MESSAGES_READ_FETCH_START = "MESSAGES_READ_FETCH_START";
export const MESSAGES_READ_FETCH_SUCCESS = "MESSAGES_READ_FETCH_SUCCESS";
export const MESSAGES_READ_FETCH_FAILURE = "MESSAGES_READ_FETCH_FAILURE";

export const LIFE_ASSURANCE_FETCH_START = "LIFE_ASSURANCE_FETCH_START";
export const LIFE_ASSURANCE_FETCH_SUCCESS = "LIFE_ASSURANCE_FETCH_SUCCESS";
export const LIFE_ASSURANCE_FETCH_FAILURE = "LIFE_ASSURANCE_FETCH_FAILURE";

export const GRADES_FETCH_START = "GRADES_FETCH_START";
export const GRADES_FETCH_SUCCESS = "GRADES_FETCH_SUCCESS";
export const GRADES_FETCH_FAILURE = "GRADES_FETCH_FAILURE";
export const CONTRIBUTION_VIEW_FETCH_START = "CONTRIBUTION_VIEW_FETCH_START";
export const CONTRIBUTION_VIEW_FETCH_SUCCESS =
  "CONTRIBUTION_VIEW_FETCH_SUCCESS";
export const CONTRIBUTION_VIEW_FETCH_FAILURE =
  "CONTRIBUTION_VIEW_FETCH_FAILURE";

//get title
export const GET_TITLE_FETCH_START = "GET_TITLE_FETCH_START";
export const GET_TITLE_FETCH_SUCCESS = "GET_TITLE_FETCH_SUCCESS";
export const GET_TITLE_FETCH_FAILURE = "GET_TITLE_FETCH_FAILURE";

//feedback page
export const FEEDBACK_FETCH_START = "FEEDBACK_FETCH_START";
export const FEEDBACK_FETCH_SUCCESS = "FEEDBACK_FETCH_SUCCESS";
export const FEEDBACK_FETCH_FAILURE = "FEEDBACK_FETCH_FAILURE";
("CONTRIBUTION_VIEW_FETCH_FAILURE");

export const FUND_SWITCH_FUTURE_FETCH_START = "FUND_SWITCH_FUTURE_FETCH_START";
export const FUND_SWITCH_FUTURE_FETCH_SUCCESS =
  "FUND_SWITCH_FUTURE_FETCH_SUCCESS";
export const FUND_SWITCH_FUTURE_FETCH_FAILURE =
  "FUND_SWITCH_FUTURE_FETCH_FAILURE";

//HELP_GUIDES page
export const HELP_GUIDES_FETCH_START = "HELP_GUIDES_FETCH_START";
export const HELP_GUIDES_FETCH_SUCCESS = "HELP_GUIDES_FETCH_SUCCESS";
export const HELP_GUIDES_FETCH_FAILURE = "HELP_GUIDES_FETCH_FAILURE";

//FAQ page
export const FAQ_FETCH_START = "FAQ_FETCH_START";
export const FAQ_FETCH_SUCCESS = "FAQ_FETCH_SUCCESS";
export const FAQ_FETCH_FAILURE = "FAQ_FETCH_FAILURE";

//Jargon page
export const JARGON_FETCH_START = "JARGON_FETCH_START";
export const JARGON_FETCH_SUCCESS = "JARGON_FETCH_SUCCESS";
export const JARGON_FETCH_FAILURE = "JARGON_FETCH_FAILURE";

//get country list
export const COUNTRY_FETCH_START = "COUNTRY_FETCH_START";
export const COUNTRY_FETCH_SUCCESS = "COUNTRY_FETCH_SUCCESS";
export const COUNTRY_FETCH_FAILURE = "COUNTRY_FETCH_FAILURE";

//get change investment article list
export const CHANGE_INVESTMENT_FETCH_START = "CHANGE_INVESTMENT_FETCH_START";
export const CHANGE_INVESTMENT_FETCH_SUCCESS =
  "CHANGE_INVESTMENT_FETCH_SUCCESS";
export const CHANGE_INVESTMENT_FETCH_FAILURE =
  "CHANGE_INVESTMENT_FETCH_FAILURE";

//lump sum withdrawal
export const LUMP_SUMS_FETCH_START = "LUMP_SUMS_FETCH_START";
export const LUMP_SUMS_FETCH_SUCCESS = "LUMP_SUMS_FETCH_SUCCESS";
export const LUMP_SUMS_FETCH_FAILURE = "LUMP_SUMS_FETCH_FAILURE";

//tax-free cash create
export const TAX_FREE_CREATE_FETCH_START = "TAX_FREE_CREATE_FETCH_START";
export const TAX_FREE_CREATE_FETCH_SUCCESS = "TAX_FREE_CREATE_FETCH_SUCCESS";
export const TAX_FREE_CREATE_FETCH_FAILURE = "TAX_FREE_CREATE_FETCH_FAILURE";

//tax-free cash stop
export const TAX_FREE_STOP_FETCH_START = "TAX_FREE_STOP_FETCH_START";
export const TAX_FREE_STOP_FETCH_SUCCESS = "TAX_FREE_STOP_FETCH_SUCCESS";
export const TAX_FREE_STOP_FETCH_FAILURE = "TAX_FREE_STOP_FETCH_FAILURE";

//Manage flexi access income
export const FLEXI_ACCESS_INCOME_FETCH_START =
  "FLEXI_ACCESS_INCOME_FETCH_START";
export const FLEXI_ACCESS_INCOME_FETCH_SUCCESS =
  "FLEXI_ACCESS_INCOME_FETCH_SUCCESS";
export const FLEXI_ACCESS_INCOME_FETCH_FAILURE =
  "FLEXI_ACCESS_INCOME_FETCH_FAILURE";

export const ILLUSTRATION_FETCH_START = "ILLUSTRATION_FETCH_START";
export const ILLUSTRATION_FETCH_SUCCESS = "ILLUSTRATION_FETCH_SUCCESS";
export const ILLUSTRATION_FETCH_FAILURE = "ILLUSTRATION_FETCH_FAILURE";

export const PAYOUT_RATE_FETCH_START = "PAYOUT_RATE_FETCH_START";
export const PAYOUT_RATE_FETCH_SUCCESS = "PAYOUT_RATE_FETCH_SUCCESS";
export const PAYOUT_RATE_FETCH_FAILURE = "PAYOUT_RATE_FETCH_FAILURE";

export const RA_CMS_FUNDS_FETCH_START = "RA_CMS_FUNDS_FETCH_START";
export const RA_CMS_FUNDS_FETCH_SUCCESS = "RA_CMS_FUNDS_FETCH_SUCCESS";
export const RA_CMS_FUNDS_FETCH_FAILURE = "RA_CMS_FUNDS_FETCH_FAILURE";

//Pension Lab consent Get & Post
//GET
export const PENSION_LAB_CONSENT_FETCH_START =
  "PENSION_LAB_CONSENT_FETCH_START";

export const PENSION_LAB_CONSENT_FETCH_SUCCESS =
  "PENSION_LAB_CONSENT_FETCH_SUCCESS";

export const PENSION_LAB_CONSENT_FETCH_FAILURE =
  "PENSION_LAB_CONSENT_FETCH_FAILURE";

//POST
export const PENSION_LAB_CONSENT_UPDATE_FETCH_START =
  "PENSION_LAB_CONSENT_UPDATE_FETCH_START";

export const PENSION_LAB_CONSENT_UPDATE_FETCH_SUCCESS =
  "PENSION_LAB_CONSENT_UPDATE_FETCH_SUCCESS";

export const PENSION_LAB_CONSENT_UPDATE_FETCH_FAILURE =
  "PENSION_LAB_CONSENT_UPDATE_FETCH_FAILURE";

// TRA change when fund switch required
export const TRA_CHANGE_WITH_FUNDSWITCH_FETCH_START =
  "TRA_CHANGE_WITH_FUNDSWITCH_FETCH_START";
export const TRA_CHANGE_WITH_FUNDSWITCH_FETCH_SUCCESS =
  "TRA_CHANGE_WITH_FUNDSWITCH_FETCH_SUCCESS";
export const TRA_CHANGE_WITH_FUNDSWITCH_FETCH_FAILURE =
  "TRA_CHANGE_WITH_FUNDSWITCH_FETCH_FAILURE";
